import { Col, ControlLabel, FormGroup, Row } from "react-bootstrap";
import { compose, graphql } from "react-apollo";

import Cleave from "cleave.js/react";
import CurrencySelect from "../Currency/CurrencySelect";
import EnumSelect from "../../elements/CustomSelect/EnumSelect";
import { FormattedMessage } from "react-intl";
import LanguageSelect from "../Language/LanguageSelect";
import Queries from "../../queries/queries2";
import React from "react";
import Switch from "react-bootstrap-switch";
import { withRouter } from "react-router-dom";

// import TaxSelect from "../Company/TaxSelect";

const data = graphql(Queries.getOnlyCompanyConditionsDeVenteQuery, {
  options: ({ companyId, language }) => {
    return {
      fetchPolicy: "cache-and-network",
      variables: {
        companyId,
        languageId: language
      }
    };
  }
});

const ClientFormBilling = ({
  updateFormValue,
  // tax,
  data,
  defaultTermDelaisPaiement,
  defaultTermNetsFinDeMois,
  relanceAuto,
  language,
  currency,
  iban,
  swift,
  companyId,
  history,
  dateLanguage
  // companyTaxBase
}) => {
  // console.log("companyId", companyId);
  // console.log("ClientFormBilling", companyId);
  let showCDVWarning = true;
  if (
    data &&
    data.company &&
    data.company &&
    data.company.documents[0] &&
    data.company.documents[0].conditionsDeVente
  ) {
    showCDVWarning = false;
  }

  return (
    <div>
      <Row>
        <Col xs={12}>
          <h4>
            <FormattedMessage id="ids_billing" />
          </h4>
          {/* <FormGroup>
            <ControlLabel>
              <FormattedMessage
                id="ClientForm_tax"
                description="client tax input field label"
                defaultMessage="TVA (%)"
              />
            </ControlLabel> */}
          {
            // <TaxSelect
            // companyId={companyId || ""}
            // value={tax && tax.id}
            // onSelected={e => {
            //   updateFormValue("tax", { value: e.element });
            //   updateFormValue("defaultTaxValue", {
            //     value: e.element.valuePourcent
            //   });
            // }}
            //   idemCheckBox={true}
            //   onCheckBoxUpdated={e =>
            //     updateFormValue("taxIdemCompany", { value: e })
            //   }
            //   // idemCheckBoxValue={companyTaxBase ? companyTaxBase.value : "20.00"}
            //   creatable
            // />
          }
          {/* </FormGroup> */}
        </Col>
      </Row>
      <Row>
        <Col xs={10} sm={6}>
          <FormGroup>
            <ControlLabel>
              <FormattedMessage id="ids_payment_deadline" />
            </ControlLabel>
          </FormGroup>
          <div className="space-between">
            <div className="width-percent-48">
              <FormGroup>
                <EnumSelect
                  enumName="TermDelaisDePaiementEnum"
                  value={defaultTermDelaisPaiement}
                  onSelected={e =>
                    updateFormValue("defaultTermDelaisPaiement", e)
                  }
                />
              </FormGroup>
            </div>
            <div className="width-percent-48">
              <FormGroup>
                <EnumSelect
                  enumName="TermNetsFinDeMoisEnum"
                  value={defaultTermNetsFinDeMois}
                  onSelected={e =>
                    updateFormValue("defaultTermNetsFinDeMois", e)
                  }
                />
              </FormGroup>
            </div>
          </div>
        </Col>
        <Col xs={2} sm={2}>
          <FormGroup>
            <ControlLabel>
              <FormattedMessage id="ids_autoReminder" />
            </ControlLabel>
            <Switch
              onText="on"
              offText="off"
              value={relanceAuto}
              onChange={(e, state) =>
                updateFormValue("relanceAuto", { value: state })
              }
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={6} sm={4}>
          <FormGroup>
            <ControlLabel>
              <FormattedMessage id="ids_language" />
            </ControlLabel>
            <LanguageSelect
              value={language}
              onSelected={e => updateFormValue("language", e)}
            />
          </FormGroup>
        </Col>
        <Col xs={2} sm={2}>
          <FormGroup>
            <ControlLabel>
              <FormattedMessage
                id="ids_currency"
                description="client currency input field label"
                defaultMessage="Devise"
              />
            </ControlLabel>
            <CurrencySelect
              value={currency}
              onSelected={e => updateFormValue("currency", e)}
            />
          </FormGroup>
        </Col>
        <Col xs={6} sm={4}>
          <FormGroup>
            <ControlLabel>
              <FormattedMessage id="ids_dateLocalization" />
            </ControlLabel>
            <LanguageSelect
              value={dateLanguage}
              onSelected={e => updateFormValue("dateLanguage", e)}
            />
          </FormGroup>
        </Col>
        {showCDVWarning && (
          <Col xs={1} sm={6}>
            <div /* onClick={ e => history.push(`/settings/documents`)}*/>
              <FormGroup>
                <ControlLabel />
                <Col xs={12} style={{ color: "red" /* , cursor: "pointer"*/ }}>
                  <i className="fa fa-lg fa-exclamation-triangle" />{" "}
                  <FormattedMessage id="ids_undefinedCDV" />
                </Col>
              </FormGroup>
            </div>
          </Col>
        )}
      </Row>
      <Row>
        <Col xs={7} sm={6}>
          <FormGroup>
            <ControlLabel>
              <FormattedMessage id="ids_iban" />
            </ControlLabel>
            <Cleave
              className="form-control"
              placeholder="FR33 2002 0202 2606 0002 4M02 606"
              name="iban"
              style={{ textTransform: "uppercase" }}
              options={{
                blocks: [4, 4, 4, 4, 4, 4, 4, 4, 4, 4],
                delimiter: " "
              }}
              value={iban}
              onChange={e => updateFormValue("iban", e.target)}
            />
          </FormGroup>
        </Col>
        <Col xs={5} sm={3}>
          <FormGroup>
            <ControlLabel>
              <FormattedMessage id="ids_swift" />
            </ControlLabel>
            <Cleave
              className="form-control"
              placeholder="AAA FR 00 000"
              name="swift"
              style={{ textTransform: "uppercase" }}
              options={{ blocks: [4, 4, 4, 4, 4, 4, 4], delimiter: " " }}
              value={swift}
              onChange={e => updateFormValue("swift", e.target)}
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
};

export default compose(data)(withRouter(ClientFormBilling));
